import { useQuery } from '@tanstack/react-query'
import { useOptimisticUpdate } from 'hooks/useOptimisticUpdate'

import { ME_PREFERENCES } from 'settings/_reactQueryConstants'

import { fetchPreferences, MePreferencesData } from '../service'
import { TranscribeAudioType, updateTranscriptionPreference as updateTranscriptionPreferenceMutation } from './service'

export interface TranscriptionData {
  data: TranscribeAudioType | undefined
  isLoading: boolean
  isError: boolean
  mutate: (data: TranscribeAudioType) => void
}

export const useTranscriptionService = (): TranscriptionData => {
  const { data, isError, isLoading } = useQuery({
    queryKey: [ME_PREFERENCES],
    queryFn: fetchPreferences,
    select: (prefs) => prefs?.transcribe_audio,
    retry: false,
    refetchOnWindowFocus: false,
  })

  const { mutate } = useOptimisticUpdate<
    TranscribeAudioType,
    MePreferencesData
  >({
    mutationFn: updateTranscriptionPreferenceMutation,
    queryKey: [ME_PREFERENCES],
    updater: (old, newValue) => ({
      ...(old || {} as MePreferencesData),
      transcribe_audio: newValue,
    })
  })

  return {
    data,
    isLoading,
    isError,
    mutate
  }
}
